module.exports = __webpack_public_path__ + "images/8426080b8bec1cacdc388ded756122c5.png";